// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"28":"bbea99cc","131":"08646b6a","219":"42fc57f5"}[chunkId] + ".chunk.js";
};